<ng-container>
  @if (!form?.get('moneyGames')?.value && derrors) {
    <info [option]="optionInfo1"> vous devez choisir au moins une option </info>
  }
  <div class="formControl mt">
    <pr-input-radio
      formControlName="moneyGames"
      direction="column"
      [isDefault]="false"
      [options]="options"
      columns="1"
      [derrors]="derrors"
    >
    </pr-input-radio>
  </div>
</ng-container>
